import React, { useEffect, useState } from "react";
import Slider from '../../Components/Sliders/Slider'
import Our_Tour from "./Cards/Our_Tour";
import Segment from './Segments/Segment'
import About from './About/About'
import Whychoose from './Why Choose/Whychoose'
import Values from './Values/Values'
// import Vehicles from './Vehicle cards/Vehicles'
import Experenise from "./Experenise/Experenise";
// import Table from './Table Ratess/Table'
import Team from './Teams/Team'
import Review from "./Teams/Reviews/Review";
import { BASE_URL } from "../../Components/Base_url/Base_Url";
function Home() {

    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [TempoService, setTempoService] = useState([]);
    const [TempoServiceloading, setTempoServiceLoading] = useState(true);
    const [BusService, setBusService] = useState([]);
    const [BusServiceloading, setBusServiceLoading] = useState(true);
    const [OurTour, setOurToure] = useState([]);
    const [OurTourloading, setOurTourLoading] = useState(true);
    const [TourGuide, setTourGuide] = useState([]);
    const [TourGuideloading, setTourGuideLoading] = useState(true);



    // ''''''''''''''''Texi id -1''''''''''
    useEffect(() => {
        fetch(`${BASE_URL}/service_master_home/?segment_id=1`)
            .then((res) => res.json())
            .then((data) => {
                setServices(data.data || []);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching services:", err);
                setLoading(false);
            });
    }, []);


    //  '''''''''''''''''''Tempo id-2''''''
    useEffect(() => {
        fetch(`${BASE_URL}/service_master_home/?segment_id=2`)
            .then((res) => res.json())
            .then((data) => {
                setTempoService(data.data || []);
                setTempoServiceLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching services:", err);
                setTempoServiceLoading(false);
            });
    }, []);


    //   ''''''''''Our tour'''
    useEffect(() => {
        fetch(`${BASE_URL}/service_master_home/?segment_id=4`)
            .then((res) => res.json())
            .then((data) => {
                setOurToure(data.data || []);
                setOurTourLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching services:", err);
                setOurTourLoading(false);
            });
    }, []);

    // '''''''''''''''''''''''Gouid- '
    useEffect(() => {
        fetch(`${BASE_URL}/service_master_home/?segment_id=5`)
            .then((res) => res.json())
            .then((data) => {
                setTourGuide(data.data || []);
                setTourGuideLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching services:", err);
                setTourGuideLoading(false);
            });
    }, []);


    //    '----------------BUs----------------'

    useEffect(() => {
        fetch(`${BASE_URL}/service_master_home/?segment_id=3`)
            .then((res) => res.json())
            .then((data) => {
                setBusService(data.data || []);
                setBusServiceLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching services:", err);
                setBusServiceLoading(false);
            });
    }, []);

    return (
        <>

            {/* <Navbar /> */}
            <Slider />
            <Our_Tour services={OurTour} loading={OurTourloading} Message={'Popular Tour Packages'} sectionParagraph={OurTour[0]?.Paragraph} />
            <Experenise />
            <Segment />
            <Our_Tour services={services} loading={loading} Message={'Texi Service'} sectionParagraph={services[0]?.Paragraph} />

            <About />
            <Our_Tour services={BusService} loading={BusServiceloading} Message={'Call For Bus Services'} sectionParagraph={BusService[0]?.Paragraph} />

            <Whychoose />

            {/* <Vehicles /> */}
            <Values />
            <Our_Tour services={TempoService} loading={TempoServiceloading} Message={'Tempo Service'} sectionParagraph={TempoService[0]?.Paragraph} />
            <Team />
            {/* <Our_Tour services={TempoService} loading={TempoServiceloading} Message={'Tempo Service'} sectionParagraph={TempoService[0]?.Paragraph} /> */}
            <Review />
            <Our_Tour services={TourGuide} loading={TourGuideloading} Message={'Call For Cabs  Our Tour  Services'} sectionParagraph={TourGuide[0]?.Paragraph} />

            {/* <Table /> */}

        </>
    )
}

export default Home